import React from 'react';
import styled from "styled-components";
import {Field, Primitive, PrimitiveObject} from "../../../Types";
import {getColumnValue} from "../../functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchengin} from "@fortawesome/free-brands-svg-icons";

function RefSingleRow({
                       value, record, schema,
                       last, first,
                        searchByPk

                   }: {
    value: Primitive,
    record: PrimitiveObject
    schema: Field,
    last: boolean,
    first: boolean,
    searchByPk?: (record: PrimitiveObject) => void
}) {

    return <Container $last={last} $first={first}>
        <td className={'edit-title-col ref'}>
            {searchByPk && <button className="id-search btn-icon" onClick={() => searchByPk(record)}>
                <FontAwesomeIcon icon={faSearchengin} title={"Шукати"} style={{width: "1.2rem", height: "1.2rem"}} className={'fa-color'}/>
            </button>}
            <span style={{marginLeft: !searchByPk ? "1.6rem" : "0"}}>
                 {schema.title.ua}
            </span>
        </td>
        <td className={'value-col'}>
            <span>
                {getColumnValue(value, schema, false, record)}
            </span>
        </td>

    </Container>
}

export default RefSingleRow;

const Container = styled.tr<{$last:boolean, $first: boolean}>`
    max-width: 100vw;

    border-top: ${({$first}) => $first ? '2px solid var(--table-border-color)' : 'none'};
    border-bottom: ${({$last}) => $last ? '2px solid var(--table-border-color)' : 'none'};

    & > td {

    }

    .value-col {
        width: auto;
    }


    & .ref {
        display: flex;
        gap: .4rem;
        
        .id-search {
            rotate: y 180deg;
        }

        & span {
            //margin-left: 1.5rem;
            font-weight: bold;
        }
    }

    

    & .title {
        text-align: right;
    }

    & .btn {
        width: 1.5rem;
        height: 1.5rem;
        display: inline-block;
    }

    & .title-icon {
        width: 1rem;
        height: 1rem;
    }


`
